/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "De droite à gauche",
		"timeZoneID": "Fuseau horaire",
		"skin": "Style",
		"metricsFileImportTask": "Nouvelle importation à partir des fichiers",
		"displayMode": "Vue par défaut",
		"credentialRenewed": "Vos données d'identification ont été renouvelées avec votre ID utilisateur et votre mot de passe en cours.",
		"productLocale": "Langue du produit",
		"toggleDisabled": "désactivé",
		"credentialChange": "Renouveler",
		"log_level_Debug": "Débogage",
		"confirmNewPassword": "Confirmer le nouveau mot de passe",
		"unsavedViewMsg2": "Vos modifications seront perdues si vous ne les sauvegardez pas.",
		"supportPortalErrorMessage": "Essayez à nouveau.  Si l'incident persiste, prenez contact avec l'administrateur.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. Eléments sous licence - Propriété d'IBM Corp. © Copyright IBM Corporation et autre(s) 2005, %{year}. IBM, le logo IBM, ibm.com et Cognos sont des marques d'International Business Machines Corp. dans de nombreux pays. La liste actualisée de toutes les marques d'IBM est disponible sur le Web à l'adresse www.ibm.com/legal/copytrade.shtml. Le présent Logiciel est soumis aux dispositions du contrat de licence inclus dans le Logiciel. Ce contrat de licence peut se trouver dans un répertoire du Logiciel ou dans une bibliothèque \"License\" ou \"Non_IBM_License\", ou être fourni sous la forme d'un exemplaire papier. Veuillez lire attentivement ce contrat avant d'utiliser le logiciel. Vous acceptez les dispositions du présent contrat en utilisant le logiciel.",
		"groupsAndRoles": "Groupes et rôles",
		"metricsMaintenanceTask": "Nouvelle maintenance",
		"email": "Courrier électronique",
		"contextual": "Contextuel",
		"resetHome": "Rétablir la valeur par défaut",
		"ltr": "De gauche à droite",
		"credentials": "Données d'identification",
		"logging_congfig_title": "Journalisation",
		"changePasswordTitle": "Modifier mon mot de passe",
		"format": "Format du rapport",
		"showUnread": "Afficher les non lus",
		"AILearning_active": "L'apprentissage de l'IA est actif :",
		"docsErrorMessage": "Essayez à nouveau.  Si l'incident persiste, prenez contact avec l'administrateur.",
		"toggleEnabled": "activé",
		"homeSetError": "Une erreur est survenue lors de la définition de la page d'accueil par défaut ; essayez de fermer cette vue, puis de la rouvrir.",
		"passwordChange": "Modifier votre mot de passe",
		"profile": "Profil",
		"pdfRestricted": "PDF (Restreint)",
		"drillThrough": "Définitions d'accès au détail",
		"homeSet": "Votre page d'accueil a été définie",
		"regionalOptions": "Options régionales",
		"myPreferences": "Mes préférences",
		"defaultHome": "Par défaut",
		"version": "Version",
		"controller": "Controller",
		"manage": "Gérer",
		"biDirectionalFeaturesEnabled": "Prise en charge des langues bidirectionnelles",
		"newFeaturesErrorTitle": "Le lien vers les nouvelles fonctionnalités ne fonctionne pas",
		"passwordMatch": "Le mot de passe correspond",
		"updateProfileAndsettings": "Mettre à jour le profil et les paramètres",
		"dashboardConsole": "Espace de travail",
		"legacyAppsSlideoutLabel": "Applications existantes disponibles",
		"logging_config_description": "La journalisation est utilisée pour le traitement des incidents. Contactez votre administrateur pour des conseils sur les paramètres.",
		"confirmDeletion": "Confirmer la suppression",
		"signInButtonText": "Connexion",
		"dataSourceCredentials": "Données d'identification du serveur de données",
		"AILearningConfigurationSlideoutAllyLabel": "Configuration de l'apprentissage de l'IA",
		"loadingSettings": "Chargement des paramètres",
		"spreadsheetMLRestricted": "Excel (Restreint)",
		"manageAILearning": "Apprentissage de l'IA",
		"xlsxDataRestricted": "Données Excel (Restreint)",
		"advanced": "Options avancées",
		"ok": "OK",
		"changeEmail": "Modification",
		"showHints": "Afficher les suggestions",
		"general": "Général",
		"xlsxData": "Données Excel",
		"newPassword": "Nouveau mot de passe",
		"hideAll": "Masquer tout",
		"confirmPassword": "Confirmation du mot de passe",
		"AILearning_config_description": "Améliorer les recommandations sur les produits en permettant à Cognos Analytics d'apprendre avec votre utilisation.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Le lien vers le portail du support ne fonctionne pas",
		"log_level_Warn": "Avertissement",
		"contentSettings": "Paramètres de contenu",
		"setHomeButton": "Définir",
		"myCapabilities": "Mes droits",
		"homePage": "Page d'accueil",
		"helpErrorMessage": "Essayez à nouveau.  Si l'incident persiste, prenez contact avec l'administrateur.",
		"loadingProfile": "Chargement du profil",
		"portal": "Portail",
		"metricsPackage": "Nouveau pack",
		"myCredentials": "Mes données d'identification",
		"credentialCreate": "Créer",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Impossible de mettre à jour le mot de passe",
		"showHiddenObjects": "Afficher les entrées masquées",
		"csv": "CSV",
		"docsErrorTitle": "Le lien vers la documentation ne fonctionne pas",
		"log_level_Error": "Erreur",
		"wrongPassword": "Authentification impossible",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Information",
		"welcomeBanner": "Bannière de bienvenue",
		"helpErrorTitle": "Le lien vers l'aide ne fonctionne pas",
		"contentLocale": "Langue du contenu",
		"pdf": "PDF",
		"oldPassword": "Ancien mot de passe",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Fonctions d'accessibilité",
		"manageLogging": "Journalisation",
		"loggingConfigurationSlideoutA11yLabel": "Configuration de la journalisation",
		"communityErrorTitle": "Le lien vers la communauté ne fonctionne pas",
		"companionApps": "Applications complémentaires",
		"setHomeLabel": "Définir l'accueil en tant que (vue actuelle)",
		"metricsExportTask": "Nouvelle exportation",
		"csvRestricted": "CSV (Restreint)",
		"newFeaturesErrorMessage": "Essayez à nouveau.  Si l'incident persiste, prenez contact avec l'administrateur.",
		"contributor": "Contributor",
		"showAll": "Afficher tout",
		"logging_active": "La journalisation est activée :",
		"html": "HTML",
		"profileAndSettings": "Profil et paramètres",
		"baseTextDirection": "Sens de base du texte",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Mot de passe",
		"invalidEmail": "Entrez une adresse de courrier électronique valide",
		"credentialCreateSuccess": "Vous avez créé vos données d'identification",
		"settings": "Paramètres",
		"restrictedFormatSelected": "Vous n'avez pas la capacité d'exécuter des rapports dans ce format, mais vous pouvez accéder aux rapports sauvegardés dans ce format.",
		"usageDataDeletionConfirmation": "La suppression des données d'utilisation réinitialise n'importe quel apprentissage d'IA.  Voulez-vous vraiment supprimer les données d'utilisation ?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Afficher les détails",
		"deleteUsageData": "Supprimer les données d'utilisation :",
		"showPassword": "Afficher le mot de passe",
		"AILearning_config_title": "Apprentissage de l'IA",
		"myPreferencesSlideoutLabel": "Profil et paramètres",
		"passWordChangeSuccess": "Vous avez modifié votre mot de passe",
		"logging_level": "Niveau de journalisation :",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Essayez à nouveau.  Si l'incident persiste, prenez contact avec l'administrateur.",
		"cancel": "Annuler",
		"shareSetError": "Cette action ne peut pas être effectuée avant la fermeture et la réouverture de cette vue.",
		"passwordNotMatch": "Le mot de passe ne correspond pas",
		"xml": "XML",
		"xmlRestricted": "XML (Restreint)",
		"openMenu": "Ouvrir le menu",
		"closeMenu": 'Fermer le menu'
});